'use strict'

$(function() {
    
    if ($('.js-form-filters').length) {
        var filterFormHeight = $('.js-filter-form').height();
        var userFilters = null;
        $('.js-filter-form').css('height', filterFormHeight);
        
        
        var init = function() {
            if (!$('.js-filter-box').hasClass('js-filter-box-categories')) {
                localforage.getItem('filters', function(err, value) {
                    userFilters = value;
                    if (userFilters !== null) {
                        loadFilters();                        
                    }
                    updateCounter();
                    if ($('.js-filter-box').attr('data-showfilters') == 0) {
                        $('.js-filter-box').addClass('-filters-active');
                    }
                });
            }
            else {
                updateCounter();
                if ($('.js-filter-box').attr('data-showfilters') == 0) {
                    $('.js-filter-box').addClass('-filters-active');
                }
            }
        };
        
        var loadFilters = function() {
            var i = 1;
            $.each(userFilters, function(index, item) {
                $.each(item, function(filterindex, filteritem) {
                    if (index === 'all') {
                        $('input.js-checkbox-all[name="' + filteritem + '"]').prop('checked', true);
                    }
                    else {
                        $('input.js-' + index + '[value="' + filteritem + '"]').prop('checked', true);
                    }
                    
                    if (filterindex + 1 === item.length && i === Object.keys(userFilters).length) {
                        if ($('.js-filter-box').attr('data-loadarticles') == 1) {
                            $('.js-form-filters').submit();
                        }
                        updateCounter();
                    }
                });
                
                i++;
            });
            
            var allSelected = userFilters.all;
        };
        
        var updateCounter = function() {
            var formData = new FormData(document.querySelector(".js-form-filters"));
            var url = '/filter.php';
            if (document.location.host === 'sekisui.eu') {
                url = '/newsroom/filter.php';
            }
            
            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                processData: false,  // tell jQuery not to process the data
                contentType: false,   // tell jQuery not to set contentType
                success: function(data, status) {
                    data = JSON.parse(data);
                    $('.js-counter').text(data.count);
                }
            });
        };
        
        var updateFilterList = function() {
            var $filterList = $('.js-filter-list');
            $filterList.html('');
            
            localforage.getItem('filters', function(err, value) {
                userFilters = value;
                if (userFilters !== null) {                    
                    $.each(userFilters, function(index, item) {
                        if (Object.keys(item).length > 1 && index !== 'all') {
                            //var filter = $('<li><span>' + Object.keys(item).length + ' ' + index + '</span></li>');
                            var filter = $('<li><span>' + Object.keys(item)[0] + '</span></li>');
                            $filterList.append(filter);
                        }
                        else {          
                            $.each(item, function(filterindex, filteritem) {
                                if (index === 'all') {
                                    var filter = $('<li><span>' + $('input.js-checkbox-all[name="' + filteritem + '"]').attr('data-name') + '</span></li>');
                                    $filterList.append(filter);
                                }
                                else {
                                    var filter = $('<li><span>' + filterindex + '</span></li>');
                                    $filterList.append(filter);
                                }
                            });
                        }
                    });
                }
            });
        };
        
        $('.js-show-filters').on('click', function(e) {
            e.preventDefault();
            
            $('.js-filter-box').removeClass('-filters-active');
        });

        $('.js-reset-filters').on('click', function(e) {
            $('.js-checkbox-all').trigger('click');

            if (!$('.js-filter-box').hasClass('js-filter-box-categories')) {
                deleteCookie('filter-interests-set');
            }

            window.setTimeout(function() {
                $('.js-save-filters').trigger('click');
            }, 20);
        });
        
        $('.js-form-filters input[type="checkbox"]').on('change', function(e) {            
            if (!$(this).hasClass('js-checkbox-all')) {
                if ($(this).parents('.js-filter-prop').find('input:checked').length === 0) {
                    $(this).parents('.js-filter-prop').find('.js-checkbox-all').prop('checked', true);
                }
                else {
                    $(this).parents('.js-filter-prop').find('.js-checkbox-all').prop('checked', false);
                }
            }
            else  {
                $(this).parents('.js-filter-prop').find('.js-checkbox-all').prop('checked', true);
            }
            updateCounter();
        });
        
        $('.js-checkbox-all').on('change', function(e) {
            if ($(this).prop('checked')) {
                $(this).parents('.js-filter-prop').find('input[type="checkbox"]:not(.js-checkbox-all)').prop('checked', false);
            }
        });
        
        $('.js-form-filters').on('submit', function(e) {
            e.preventDefault();
            var formData = new FormData(document.querySelector(".js-form-filters"));
            var filters = {
                companies: {},
                countries: {},
                categories: {},
                types: {},
                all: []
            };
            var url = '/filter.php';
            if (document.location.host === 'sekisui.eu') {
                url = '/newsroom/filter.php';
            }
            
            formData.append('output', 1);               
            
            
            $.each($('input[name="categories[]"]:checked'), function(index, item) {
                filters.categories[$(item).attr('data-text')] = $(item).val();
            });
            $.each($('input[name="companies[]"]:checked'), function(index, item) {
                filters.companies[$(item).attr('data-text')] = $(item).val();
            });
            $.each($('input[name="countries[]"]:checked'), function(index, item) {
                filters.countries[$(item).attr('data-text')] = $(item).val();
            });
            $.each($('input[name="types[]"]:checked'), function(index, item) {
                filters.types[$(item).attr('data-text')] = $(item).val();
            });
            $.each($('input.js-checkbox-all:checked'), function(index, item) {
                filters.all.push($(item).attr('name'));
            });
            
            if (!$('.js-filter-box').hasClass('js-filter-box-categories')) {
                localforage.setItem('filters', filters);
                setCookie('filter-interests', JSON.stringify(filters), 360);
                setCookie('filter-interests-set', 1, 360);
                
                if ($('.js-filter-box').attr('data-loadarticles') == 1) {
                    $.ajax({
                        url: url,
                        type: 'POST',
                        data: formData,
                        processData: false,  // tell jQuery not to process the data
                        contentType: false,   // tell jQuery not to set contentType
                        dataType: 'html',
                        success: function(data, status) {
                            $('.js-filter-box').addClass('-filters-active');
                            updateFilterList();
                            
                            window.setTimeout(function() {
                                $('.js-filter-articles-parent').removeClass('is-hidden');
                                $('.js-filter-articles').html(data);
                                initMasonry();
                                
                                if (e.originalEvent) {
                                    scrollTo('#your-interests');
                                }
                            }, 1000);
                        }
                    });
                }
                else {
                    var location = document.location.toString();
                    var pos = document.location.toString().indexOf("page/");
                    if (pos > 0) {
                        location = location.substr(0, pos);
                    }
                    pos = location.indexOf("?c=");
                    if (pos > 0) {
                        location = location.substr(0, pos);
                    }
                    
                    document.location = location;   
                }
            }
            else {
                var location = document.location.toString();
                var cat = $('.js-filter-box').attr('data-cat');
                var pos = document.location.toString().indexOf("page/");
                if (pos > 0) {
                    location = location.substr(0, pos);
                }
                pos = location.indexOf("?c=");
                if (pos > 0) {
                    location = location.substr(0, pos);
                }
                
                setCookie('filter-cat-' + cat, JSON.stringify(filters), 1);
                document.location = location;                
            }
        });
        
        
        
        init();
    }
    
});